import React, { useState, useEffect } from "react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import * as yup from "yup";
import {
  Form as FormUi,
  Container, TextArea, Dropdown
} from "semantic-ui-react";
import { MyNormalInput, MyNormalCheckBox } from "../dynamicComponent/myInputs";
import ReadAxios from "../axiosComponent/read";
import AddSKUType from "./addSkuTypeModal";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import CreateAxios from "../axiosComponent/create";
import UpdateAxios from "../axiosComponent/update";
import { translate } from "react-i18next";
import { isEmpty } from "lodash";
import { AllRegex } from "../../utils/validation";
import { INVALID_FIELDS, REQUIRED_FIELDS } from "../../utils/validationConstant";
import { isProductFieldisRequired } from "../../features/features";
import cogoToast from "cogo-toast";
import { FEATURES } from "../../utils/constant";

const currentUser = Number(localStorage.getItem("customerNumber"));

const InsertSku = ({ values, setFieldValue, touched, errors, t, editData }) => {
  const [skuTypeList, setskuTypeList] = useState([]);

  useEffect(() => {
    getSKUList();
  }, []);

  useEffect(() => {
    if(editData.width !== values.width &&  editData.length !==values.length && editData.height !==values.height){
      setVolumeBycal()
    }
  }, [values.width, values.length, values.height]);

  const getSKUList = () => {
    ReadAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/service_category` }).then((result) => {
      let dataArray = isEmpty(result) ? [] : result.data.resultSet;
      setskuTypeList(
        dataArray.map((item, index) => {
          return {
            raw: { ...item },
            index,
            text: item.serviceCategory,
            key: item.serviceCategoryId,
            value: item.serviceCategoryId,
            raw : item
          };
        })
      );
    });
  };

  const setVolumeBycal = (e) => {
    values.width && values.length && values.height
      ? setFieldValue("volume", values.length * values.width * values.height)
      : setFieldValue("volume", 0);
  };

  const setSkuTypeValue = (name, data) => {
    setFieldValue("skuTypeId", data.value);
    if (data.value) {
      let skuTypeMaster = data.options.find((ele) => ele.value == data.value)?.raw;
      if (data.value && skuTypeMaster) {
        setFieldValue("skuTypeName", skuTypeMaster.serviceCategory);
        setFieldValue("skuTypeCode",skuTypeMaster.serviceCategoryCode)
      } else {
        setFieldValue("skuTypeName", "");
        setFieldValue("skuTypeCode","")
      }
    }
  };

  return (
    <React.Fragment>
      <Formiker>
        <div className="container-fluid animated slideInDown pad w3-white">
          <div className="m-3 pl-3">
            <div className="ui form">
              <small className="form-text text-muted w3-text-red font-weight-bold mb-2">Note: Weight is in KG and Height, Width and Length is in CM</small>
              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.sku_code.title") || "Product Code"}
                  </label>
                </FormUi.Field>
                <FormUi.Field className="display-grid-center-imp" width={4} error={touched.skuCode && errors.skuCode ? true : false}                >
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="skuCode"
                    placeholder={t("create.sku_code.placeholder") || "Code"}
                  />
                  {touched.skuCode && errors.skuCode ? (
                    <div className="error-msg">
                      {errors.skuCode}
                    </div>
                  ) : null}
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.sku_name.title") || "Product Name"}<span className="red"> *</span>
                  </label>
                </FormUi.Field>
                <FormUi.Field className="display-grid-center-imp" width={4} error={touched.skuName && errors.skuName ? true : false}>
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="skuName"
                    placeholder={t("create.sku_name.placeholder") || "Name"}
                  />
                  {touched.skuName && errors.skuName ? (
                    <div className="error-msg">
                      {errors.skuName}
                    </div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>
              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.sku_unit.title") || "No. Of SKU Units"} {FEATURES.isSkuUnitMandatoryInSku ? <span className="red">*</span> : ''}
                  </label>
                </FormUi.Field>
                <FormUi.Field width={4} className="display-grid-center-imp" error={touched.noUnitSku && errors.noUnitSku ? true : false}>
                  <Fieldmik
                    type="number"
                    min={0}
                    className="ui input"
                    name="noUnitSku"
                    placeholder={t("create.sku_unit.placeholder") || "Units"}
                  />
                  {touched.noUnitSku && errors.noUnitSku ? (
                    <div className="error-msg">
                      {errors.noUnitSku}
                    </div>
                  ) : null}
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.weight.title") || "Weight"} {FEATURES.isWeightMandatoryInSku ? <span className="red"> *</span> : ''}
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={touched.weight && errors.weight ? true : false}
                >
                  <Fieldmik
                    className="ui input"
                    name="weight"
                    placeholder={t("create.weight.placeholder") || "Weight"}
                  />

                  {errors.weight && touched.weight ? (
                    <div className="error-msg">
                      {errors.weight}
                    </div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>

              <FormUi.Group inline>
              <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.sku_type.title") || "Product Category"}<span className="red"> *</span>
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  className="display-grid-center-imp"
                  width={4}
                  error={
                    touched.skuTypeId &&
                      errors.skuTypeId ? true
                      : false
                  }
                >
                  <div className="container">
                    <div className="row">
                    <div className="col-xs-10 pr-1">
                      <Dropdown
                        clearable
                        style={{ width: "100%", float: "left" }}
                        search
                        selection
                        placeholder={t("create.sku_type.placehooder") || "Product Category"}
                        onChange={(name, data) => setSkuTypeValue(name, data)}
                        options={skuTypeList}
                        value={values.skuTypeId}
                      />
                    </div>
                    <div className="col-xs-2 pl-2">
                      <AddSKUType getSKUList={getSKUList} key={new Date().getTime()}/>
                    </div>
                    </div>
                  </div>
                  {touched.skuTypeId &&
                    errors.skuTypeId ? (
                    <div className="error-msg">
                      {errors.skuTypeId}
                    </div>
                  ) : null}

                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
                <FormUi.Field width={2}>
                  <label className="labelName">
                  {t("create.sku_type_code.title") || "Product Category Code"}
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={touched.skuTypeCode && errors.skuTypeCode ? true : false}
                >
                  <Fieldmik
                    min={0}
                    disabled
                    className="ui input"
                    name="skuTypeCode"
                    placeholder={t("create.sku_type_code.placehooder") || "Product Category Code"}
                  />
                  {errors.skuTypeCode && touched.skuTypeCode ? (
                    <div className="error-msg">
                      {errors.skuTypeCode}
                    </div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>
              
                <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.net_gross.title") || "Net Gross"} {FEATURES.isNetGrossMandatoryInSku ? <span className="red"> *</span> : ''}
                  </label>
                </FormUi.Field>
                <FormUi.Field width={4} className="display-grid-center-imp" error={touched.netgrossRatio && errors.netgrossRatio ? true : false}>
                  <Fieldmik
                    component={MyNormalInput}
                    label={{ basic: true, content: "%" }}
                    labelPosition="right"
                    type="number"
                    min={0}
                    className="ui input"
                    name="netgrossRatio"
                    placeholder={
                      t("create.net_gross.placeholder") || "Net Gross %"
                    }
                  />
                  {touched.netgrossRatio && errors.netgrossRatio ? (
                    <div className="error-msg">
                      {errors.netgrossRatio}
                    </div>
                  ) : null}
                </FormUi.Field>
                <FormUi.Field width={2} />
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.height.title") || "Height"} {FEATURES.isHeightMandatoryInSku ? <span className="red"> *</span> : null}
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={touched.height && errors.height ? true : false}
                >
                  <Fieldmik
                    min={0}
                    className="ui input"
                    name="height"
                    placeholder={t("create.height.placeholder") || "Height"}
                    onBlur={(e) => setVolumeBycal(e)}
                  />
                  {touched.height && errors.height ? (
                    <div className="error-msg">
                      {errors.height}
                    </div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>
              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.width.title") || "Width"}  {FEATURES.isWidthMandatoryInSku ? <span className="red"> *</span> : null}
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={touched.width && errors.width ? true : false}
                >
                  <Fieldmik
                    min={0}
                    className="ui input"
                    name="width"
                    placeholder={t("create.width.placeholder") || "Width"}
                    onBlur={(e) => setVolumeBycal(e)}
                  />
                  {touched.width && errors.width ? (
                    <div className="error-msg">
                      {errors.width}
                    </div>
                  ) : null}
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.length.title") || "Length"}  {FEATURES.isLengthMandatoryInSku ? <span className="red"> *</span> : null}
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={touched.length && errors.length ? true : false}
                >
                  <Fieldmik
                    min={0}
                    className="ui input"
                    name="length"
                    placeholder={t("create.length.placeholder") || "Length"}
                    onBlur={(e) => setVolumeBycal(e)}
                  />
                  {touched.length && errors.length ? (
                    <div className="error-msg">
                      {errors.length}
                    </div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>
              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.volume.title") || "Volume"} {FEATURES.isVolumeMandatoryInSku ? <span className="red"> *</span> : ''}
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={touched.volume && errors.volume ? true : false}
                >
                  <Fieldmik
                    min={0}
                    disabled
                    className="ui input"
                    name="volume"
                    placeholder={t("create.volume.placeholder") || "Volume"}
                  />
                  {errors.volume && touched.volume ? (
                    <div className="error-msg">
                      {errors.volume}
                    </div>
                  ) : null}
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.description.title") || "Description"}</label> {FEATURES.isDescMandatoryInSku ? <span className="red"> *</span> : null}
                </FormUi.Field>
                <FormUi.Field width={4} className="display-grid-center-imp" error={touched.skuDescription && errors.skuDescription ? true : false}>
                  <Fieldmik
                    as={TextArea}
                    className="ui input"
                    name="skuDescription"
                    placeholder={
                      t("create.description.placeholder") || "Description"
                    }
                  />
                  {touched.skuDescription && errors.skuDescription ? (
                    <div className="error-msg">
                      {errors.skuDescription}
                    </div>
                  ) : null}
                </FormUi.Field>
                </FormUi.Group>
              <FormUi.Group inline>
                  <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.is_self_product_service.title") || "Is Self Product Service"}</label>
                </FormUi.Field>
                <FormUi.Field width={4} className="display-grid-center-imp">
                <Fieldmik className="mt-4" component={MyNormalCheckBox} checked={values.isSelfProductService} name="isSelfProductService"
                onChangeExtra={(data)=>{
                  if(data.checked === false) setFieldValue('psLineItemGLCode','')
                }} />
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
                {values?.isSelfProductService == true &&
                <>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.gl_code.title") || "GL Code"}</label>
                </FormUi.Field>
                <FormUi.Field width={4} className="display-grid-center-imp" error={touched.psLineItemGLCode && errors.psLineItemGLCode ? true : false}>
                  <Fieldmik
                    component={MyNormalInput}
                    className="ui input"
                    value = {values?.psLineItemGLCode?.trim()}
                    name="psLineItemGLCode"
                    placeholder={
                      t("create.gl_code.placeholder") || "GL Code"
                    }
                    maxLength={30}
                  />
                  {touched.psLineItemGLCode && errors.psLineItemGLCode ? (
                    <div className="error-msg">
                      {errors.psLineItemGLCode}
                    </div>
                  ) : null}
                </FormUi.Field>
                </>}
              </FormUi.Group>

              <FormUi.Group inline>
                  <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.is_food.title") || "Is Food Item"}</label>
                </FormUi.Field>
                <FormUi.Field width={4} className="display-grid-center-imp">
                <Fieldmik className="mt-4" component={MyNormalCheckBox} checked={values.isFoodItem} name="isFoodItem"/>
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
              </FormUi.Group>

            </div>
          </div>
        </div>
        <Container className="p-3" textAlign="center">
          <button
            className="w3-button w3-blue w3-hover-blue w3-round w3-small"
            type="submit"
          >
            {t("create.action_button.submit") || "Submit"}
          </button>
        </Container>
      </Formiker>
    </React.Fragment>
  );
};

const FormikSku = withFormik({
  validationSchema: yup.object({
    skuCode: yup.string().optional().nullable() ,
    skuName: yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).matches(AllRegex.AltName, INVALID_FIELDS.INVALID_NAME),
    noUnitSku: yup.number().typeError(INVALID_FIELDS.INVALID_NUMBER).min(0, INVALID_FIELDS.MUST_BE_GREATER_THAN_ZERO),
    skuTypeId: yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED),
    weight: yup.number().typeError(INVALID_FIELDS.INVALID_NUMBER).optional().min(0, INVALID_FIELDS.MUST_BE_GREATER_THAN_ZERO),
    volume: yup.number().typeError(INVALID_FIELDS.INVALID_NUMBER).optional().min(0, INVALID_FIELDS.MUST_BE_GREATER_THAN_ZERO),
    netgrossRatio: yup.number().typeError(INVALID_FIELDS.INVALID_NUMBER).min(0, INVALID_FIELDS.MUST_BE_GREATER_THAN_ZERO),
    height: yup.number().typeError(INVALID_FIELDS.INVALID_NUMBER).optional().min(0, INVALID_FIELDS.MUST_BE_GREATER_THAN_ZERO),
    width: yup.number().typeError(INVALID_FIELDS.INVALID_NUMBER).optional().min(0, INVALID_FIELDS.MUST_BE_GREATER_THAN_ZERO),
    length: yup.number().typeError(INVALID_FIELDS.INVALID_NUMBER).optional().min(0, INVALID_FIELDS.MUST_BE_GREATER_THAN_ZERO),
    skuDescription: yup.string().optional(),
    psLineItemGLCode : yup.string().optional().nullable().matches(AllRegex.WITHOUT_SPECIAL_CHARECTERS_AND_SPACE, INVALID_FIELDS.INVALID_FIELD("GL Code"))
  }),
  enableReinitialize: true,
  mapPropsToValues: (props) => {
    return {
      skuCode: props?.editData?.skuCode || "",
      skuName: props?.editData?.skuName || "",
      noUnitSku: props?.editData?.noUnitSku || "",
      skuTypeId: props?.editData?.skuTypeId || "",
      skuTypeName: props?.editData?.skuTypeName || "",
      skuTypeCode: props?.editData?.skuTypeCode || "",
      weight: props?.editData?.weight || "",
      volume: props?.editData?.volume || "",
      netgrossRatio: props?.editData?.netgrossRatio || "",
      height: props?.editData?.height || "",
      width: props?.editData?.width || "",
      length: props?.editData?.length || "",
      skuDescription: props?.editData?.skuDescription || "",
      isSelfProductService : props?.editData?.isSelfProductService || false,
      psLineItemGLCode : props?.editData?.psLineItemGLCode ||"",
      isFoodItem : props?.editData?.isFoodItem == 1 ? true :false
    };
  },
  async handleSubmit(values, { props }) {
    values.skuCode = values.skuCode && values.skuCode.trim()
    values.skuDescription = values.skuDescription && values.skuDescription.trim()
    values.skuName = values.skuName && values.skuName.trim()
    values.isFoodItem = values.isFoodItem ? "1" : "0"
    if (props.editData.skuMasterId) {
      UpdateAxios({
        url: "skuMaster",
        payload: { ...values },
        uniqueId: props.editData.skuMasterId,
      })
        .then((res) => {
          if (res.data.status === 204) {
            cogoToast.error(res.data.message);
          }
          else {
            let alert = {
              type: "success",
              messageHeader: "Success",
              messageBody: res.data.message,
            };
            props.successAlertDispatcher(alert);
            props.onFormSubmit();
          }
        })
        .catch((err) => {
          let alert = {
            type: "error",
            messageHeader: "Error",
            messageBody: err.data.message,
          };
          console.log(err);
          props.errorAlertDispatcher(alert);
        });
    } else {
      CreateAxios({
        url: "skuMaster",
        payload: { ...values },
      })
        .then((res) => {
          if (res.data.status === 204) {
            cogoToast.error(res.data.message);
          }
          else {
            let alert = {
              type: "success",
              messageHeader: "Success",
              messageBody: res.data.message,
            };
            props.successAlertDispatcher(alert);
            props.onFormSubmit();
          }
        })
        .catch((err) => {
          console.log("error sku", err);
          let alert = {
            type: "error",
            messageHeader: "Error",
            messageBody: err.data.message,
          };
          props.errorAlertDispatcher(alert);
        });
    }
  },
})(InsertSku);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("sku")(FormikSku)
);
